var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowingUpWoman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m503.5 331.3c-13.445-32.355-32.781-53.05-49.307-65.84h-133.934c-16.526 12.791-35.862 33.486-49.308 65.84l116.515 9z",
    fill: "#ffa6d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.944 331.3c-1.591 3.829-3.1 7.82-4.512 11.98-1.109 3.269 1.289 6.668 4.741 6.668h232.104c3.452 0 5.85-3.399 4.741-6.668-1.412-4.161-2.921-8.152-4.512-11.98z",
    fill: "#f690d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.225 306.096 26.093-29.575 8.094-29.575h-68.374-.022l8.105 29.575z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.592 320.653-34.34-55.201c18.058-13.965 32.765-18.506 32.765-18.506l34.209 59.15-25.701 16.154c-2.355 1.48-5.464.764-6.933-1.597z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.858 320.653 34.34-55.201c-18.058-13.965-32.764-18.506-32.764-18.506l-34.209 59.15 25.701 16.154c2.354 1.48 5.463.764 6.932-1.597z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m445.707 227.94c4.205 11.787 15.537 17.335 24.882 17.335 19.662 0 37.706-14.617 40.343-41.083-2.801-12.164-10.952-22.282-21.853-27.733 0 0-24.664 1.105-24.664 1.04v.065z",
    fill: "#c1a19d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.589 236.275c-9.346 0-17.954-3.112-24.882-8.335l-8.261-.678-.96 9.735c7.47 10.826 19.955 17.926 34.103 17.926 22.871 0 41.411-18.54 41.411-41.411 0-3.207-.378-6.323-1.068-9.32-4.233 18.376-20.682 32.083-40.343 32.083z",
    fill: "#af9290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.576 132.507s12.095-118.227-102.349-118.227c-114.445 0-102.349 118.227-102.349 118.227z",
    fill: "#c1a19d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.524 144.973c0 16.082 13.116 25.515 24.097 25.515l11.376-11.637 9-13.878-9-13.877c-3.433-1.687-7.293-2.637-11.376-2.637-10.981 0-20.356 6.854-24.097 16.514z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.524 144.973c-1.12 2.893-1.741 6.035-1.741 9.324 0 14.27 11.568 25.839 25.838 25.839 4.083 0 7.944-.951 11.377-2.637l9-9.374-9-9.274c-3.433 1.687-7.293 2.637-11.377 2.637-10.981 0-20.356-6.854-24.097-16.515z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.889 144.973c0 16.082-13.116 25.515-24.097 25.515l-11.377-11.637-9-13.878 9-13.877c3.433-1.687 7.293-2.637 11.377-2.637 10.981 0 20.356 6.854 24.097 16.514z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.889 144.973c1.12 2.893 1.741 6.035 1.741 9.324 0 14.27-11.568 25.839-25.838 25.839-4.083 0-7.944-.951-11.377-2.637l-9-9.374 9-9.274c3.433 1.687 7.293 2.637 11.377 2.637 10.981 0 20.356-6.854 24.097-16.515z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.206 245.125c42.641 0 77.209-36.53 77.209-86.209v-27.82c-25.021-19.188-42.661-50.132-49.226-62.849-1.48-2.868-5.238-3.608-7.697-1.517-13.805 11.737-54.963 45.157-97.494 64.366v27.825c-.001 51.995 34.568 86.204 77.208 86.204z",
    fill: "#fdd4bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.206 236.125c-42.641 0-77.209-34.568-77.209-77.209v18.648c0 42.641 34.568 77.209 77.209 77.209 42.641 0 77.209-34.568 77.209-77.209v-18.648c0 42.641-34.567 77.209-77.209 77.209z",
    fill: "#f7c4a8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#eef2f5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 342.074,
    cy: 153.841,
    rx: 32.118,
    ry: 32.118,
    transform: "matrix(.982 -.189 .189 .982 -22.92 67.465)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.339,
    cy: 153.841,
    rx: 32.118,
    ry: 32.118,
    transform: "matrix(.29 -.957 .957 .29 159.814 523.048)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m210.188 331.435c-25.231-58.671-72.216-73.17-72.216-73.17h-.02c-9.169 4.536-19.489 7.096-30.41 7.096-10.922 0-21.241-2.561-30.41-7.096h-.02s-46.985 14.499-72.216 73.17l102.36 9z",
    fill: "#9dc6fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.899 331.435c-1.638 3.808-3.186 7.799-4.622 11.986-1.119 3.261 1.299 6.662 4.747 6.662h205.036c3.448 0 5.866-3.401 4.747-6.662-1.437-4.186-2.985-8.178-4.623-11.986z",
    fill: "#80b4fb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m107.544 299.988c29.13 0 30.428-41.723 30.428-41.723h-.019-60.821-.015c-.001.001 1.297 41.723 30.427 41.723z",
    fill: "#fdd4bb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m198.605 156.462s10.759-105.167-91.044-105.167c-101.802 0-91.043 105.167-91.043 105.167z",
    fill: "#af665a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.195 230.591c14.532 31.953 47.126 16 47.254 15.988h.005c-4.605-36.098-38.224-50.092-38.23-50.095v.058c0 .001-9.029 34.049-9.029 34.049z",
    fill: "#af665a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.195 230.591-8.351 1.115 1.882 8.287.001.005c11.66 22.694 38.314 25.272 48.98 25.356 2.638.021 4.821-2.021 5.033-4.651.405-5.043.27-9.745-.289-14.124-.129.012-29.96 2.633-47.256-15.988z",
    fill: "#a05c53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.891 230.591c-14.532 31.953-47.126 16-47.254 15.988-.002 0-.003 0-.004 0 4.606-36.098 38.224-50.092 38.23-50.095v.058c0 .001 9.028 34.049 9.028 34.049.001 0 .001 0 0 0z",
    fill: "#af665a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.892 230.591 8.352 1.115-1.882 8.287-.001.005c-11.66 22.694-38.314 25.272-48.98 25.356-2.638.021-4.821-2.021-5.032-4.651-.405-5.043-.269-9.745.289-14.124.127.012 29.958 2.633 47.254-15.988z",
    fill: "#a05c53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.744 189.182 10.12-11.346 9-11.314-9-11.314c-3.054-1.5-6.488-2.346-10.12-2.346-9.374 0-17.431 5.614-21.008 13.66 0 17.735 11.634 22.66 21.008 22.66z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.736 166.522c-1.267 2.85-1.977 6.003-1.977 9.324 0 12.694 10.29 22.984 22.984 22.984 3.632 0 7.066-.846 10.12-2.346l9-9.382-9-9.266c-3.054 1.5-6.488 2.346-10.12 2.346-9.373 0-17.43-5.614-21.007-13.66z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.343 189.182-10.12-11.346-9-11.314 9-11.314c3.054-1.5 6.488-2.346 10.12-2.346 9.374 0 17.431 5.614 21.008 13.66-.001 17.735-11.635 22.66-21.008 22.66z",
    fill: "#ebbaa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.35 166.522c1.267 2.85 1.977 6.003 1.977 9.324 0 12.694-10.29 22.984-22.984 22.984-3.632 0-7.066-.846-10.12-2.346l-9-9.382 9-9.266c3.054 1.5 6.488 2.346 10.12 2.346 9.373 0 17.43-5.614 21.007-13.66z",
    fill: "#e8a990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.543 255.574c37.931 0 68.68-32.046 68.68-77.68v-22.687c-17.474-7.86-36.187-30.896-43.316-40.282-1.668-2.196-4.784-2.637-6.996-.99-12.581 9.365-52.514 37.245-87.048 41.272v22.687c.001 52.697 30.75 77.68 68.68 77.68z",
    fill: "#fdd4bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.544 246.574c-37.931 0-68.68-30.749-68.68-68.68v18.648c0 37.931 30.749 68.68 68.68 68.68 37.931 0 68.68-30.749 68.68-68.68v-18.648c0 37.931-30.749 68.68-68.68 68.68z",
    fill: "#f7c4a8"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m479.38 409.813-88.228-21.627c-3.909-.958-7.298 2.843-5.901 6.616l5.899 15.929s-123.585 65.662-353.583-7.829c-3.043-.972-5.787-.613-8.011.558 57.762 48.82 219.425 114.657 378.223 63.063l6.772 7.384c-.012.012-.024.023-.036.035.012-.004.024-.008.036-.012l7.595 20.511c1.428 3.858 6.637 4.452 8.898 1.016l51.332-78.014c1.907-2.894.371-6.804-2.996-7.63z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.779 457.524c-158.812 51.598-299.737-7.208-378.244-54.075-6.416 3.397-8.448 13.596-.528 18.335 79.513 47.581 223.618 107.779 385.544 52.124v-11.463c0-3.514-3.429-6.007-6.772-4.921z",
    fill: "#e84642"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m431.128 169.796c4.3 0 7.785-3.485 7.785-7.785v-12.531c0-4.3-3.485-7.785-7.785-7.785s-7.785 3.485-7.785 7.785v12.531c0 4.299 3.485 7.785 7.785 7.785z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.802 169.796c4.3 0 7.785-3.485 7.785-7.785v-12.531c0-4.3-3.485-7.785-7.785-7.785s-7.785 3.485-7.785 7.785v12.531c-.001 4.299 3.485 7.785 7.785 7.785z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.465 218.269c16.464 0 24.857-9.716 27.221-15.458 1.636-3.976-.26-8.526-4.235-10.164-3.977-1.637-8.526.261-10.164 4.235-.023.059-2.842 5.816-12.822 5.816s-12.799-5.757-12.823-5.816c-1.637-3.975-6.187-5.872-10.163-4.235s-5.871 6.188-4.235 10.164c2.364 5.742 10.758 15.458 27.221 15.458z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.739 190.511c4.3 0 7.785-3.485 7.785-7.785v-11.146c0-4.3-3.485-7.785-7.785-7.785s-7.785 3.485-7.785 7.785v11.146c0 4.3 3.485 7.785 7.785 7.785z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.771 190.511c4.3 0 7.785-3.485 7.785-7.785v-11.146c0-4.3-3.485-7.785-7.785-7.785s-7.785 3.485-7.785 7.785v11.146c-.001 4.3 3.484 7.785 7.785 7.785z",
    fill: "#565d76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.245 219.347c2.185 5.305 9.91 14.283 25.01 14.283s22.826-8.978 25.01-14.283c1.636-3.976-.259-8.526-4.235-10.163-3.978-1.637-8.526.26-10.164 4.235-.018.047-2.284 4.641-10.611 4.641-8.328 0-10.593-4.594-10.612-4.641-1.637-3.975-6.186-5.872-10.163-4.235-3.976 1.636-5.872 6.187-4.235 10.163z",
    fill: "#f95750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.339 113.953c-19.336 0-35.497 13.831-39.123 32.118h-12.02c-3.626-18.287-19.787-32.118-39.122-32.118-21.995 0-39.889 17.893-39.889 39.888s17.893 39.889 39.889 39.889c19.336 0 35.496-13.831 39.122-32.118h12.019c3.626 18.288 19.787 32.118 39.123 32.118 21.994 0 39.888-17.893 39.888-39.889.001-21.994-17.893-39.888-39.887-39.888zm-90.265 64.236c-13.426 0-24.348-10.923-24.348-24.348s10.923-24.347 24.348-24.347 24.347 10.923 24.347 24.347c.001 13.425-10.922 24.348-24.347 24.348zm90.265 0c-13.426 0-24.348-10.923-24.348-24.348s10.923-24.347 24.348-24.347 24.347 10.923 24.347 24.347c.001 13.425-10.922 24.348-24.347 24.348z",
    fill: "#af665a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingUpWoman);
export default __webpack_public_path__ + "static/media/growing-up-woman.bb9ed7a0ea7d490bedb77e23e7a4aa0d.svg";
export { ForwardRef as ReactComponent };